"use strict";

import React, {Component} from "react";
import {types, PropTypes} from "Subschema";
import CustomMaskedInput from "./CustomMaskedInput";
const cardConfig = require('./cardConfig');

export default class Card extends Component {
    static propTypes = {
        "onChange": PropTypes.targetEvent,
        "onChangeCVCLength": PropTypes.valueEvent,
        "onChangeCardType": PropTypes.valueEvent,
        "style": PropTypes.style,
        "formatter": PropTypes.string,
        "error": PropTypes.error
    };
    static defaultProps = {
        "formatter": '#### #### #### #### ###'
    };
    static contextTypes = {
        maskedInoutUnsupported: React.PropTypes.bool
    }
    static injectedProps = {
        "onChangeCVCLength": "..cvcLength",
        "onChangeCardType": "..cardType",

        "style": "Card"
    };

    constructor(props, ...rest) {
        super(props, ...rest);
        this.handleValue(props.value, props.formatter);
    }

    componentWillReceiveProps(props) {
        if (props.value !== this.props.value) {
            // avoid null value dead loop
            this.handleValue(props.value, props.formatter);
        }
    }

    handleValue(valueCard, formatter) {
        const cardConf = cardConfig.match(valueCard);
        if (cardConf) {
            if (cardConf.type !== this.cardType) {
                this.formatter = cardConf.formatter.replace(/\#/g, '1');
                this.cardType = cardConf.type;
                this.props.onChangeCVCLength(cardConf.cvcLength);
            }
        } else {
            this.formatter = formatter.replace(/\#/g, '1');
            this.cardType = null;
        }
        this.props.onChangeCardType(this.cardType);
    }


    render() {
        const {className, error, style, formatter, creditCardClass, hasErrorClass, onChange, onChangeCardType, onChangeCVCLength, ...props} = this.props;
        return <span className={className}>
            <CustomMaskedInput {...props} placeholderChar=' ' mask={this.formatter} onChange={this.props.onChange}/>
            <i className={`${style[this.cardType]} ${creditCardClass} ${error ? hasErrorClass : ''}`}/>

        </span>
    }
}



/** WEBPACK FOOTER **
 ** ./src/types/card/Card.jsx
 **/